var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bpm-button',{staticClass:"btn",class:{'black': _vm.black, 'danger': _vm.danger},attrs:{"variant":"success"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_vm._v(_vm._s(_vm.btn_name))]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }